module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_08@3x-6eedecf395695b31ba2135631588a039.webp";